import {get as dotPropGet} from 'dot-prop';

import supportedLanguages from './../../locales/manifest.json';
import messageBundle from './../../locales/bundles/en.json';

const fallbackLanguage = 'en';
const browserLanguage = navigator ? navigator.language || navigator.userLanguage : fallbackLanguage;

const translations = {...messageBundle, supportedLanguages, usedLanguage: fallbackLanguage};

const getParentLanguage = (language) => (language.replace(/-.*?$/, ''));

const stripHtmlAndSpace = (message) => (typeof(message) === 'string' ? message.replace(/<[^>]+>/ig, '').replace(/\s{2,}/g, ' ') : message);

const setPropertiesByLocale = (locale = browserLanguage) => {
    let usedLanguage, messagePromise, messageFile;
    locale = locale ? locale : browserLanguage;
    if (supportedLanguages[locale]) {
        usedLanguage = locale;
    } else if (supportedLanguages[getParentLanguage(locale)]) {
        usedLanguage = getParentLanguage(locale);
    } else if (supportedLanguages[browserLanguage]) {
        usedLanguage = browserLanguage;
    } else if (supportedLanguages[getParentLanguage(browserLanguage)]) {
        usedLanguage = getParentLanguage(browserLanguage);
    } else {
        usedLanguage = fallbackLanguage;
    }
    if (usedLanguage !== translations.usedLanguage) {
        (() => {
            // message bundle
            messageFile = dotPropGet(translations, `supportedLanguages.${usedLanguage}.files.messageBundle`) || `${fallbackLanguage}.json`;
            messagePromise = import(`./../../locales/bundles/${messageFile}`).then(json => {
                Object.assign(translations, JSON.parse(JSON.stringify(json)), {usedLanguage, supportedLanguages});
            });
        })();
        return Promise.all([messagePromise]);
    } else {
        return Promise.resolve();
    }
};

const getUsedLanguage = () => (dotPropGet(translations, `usedLanguage`) || fallbackLanguage);

const getSupportedLanguages = () => (dotPropGet(translations, `supportedLanguages`) || {});

const getMessage = (key, params) => {
    let prop = stripHtmlAndSpace(dotPropGet(translations, key));
    if (typeof(prop) === 'string') {
        let validParams = Array.isArray(params) ? params : ['number', 'string'].includes(typeof(params)) ? [params] : [];
        validParams.forEach((v, i) => {
            prop = prop.replace(new RegExp(`\\{\\{${i}\\}\\}`, 'g'), v);
        });
        return prop;
    } else {
        return key;
    }
};

export {getMessage as default, getMessage, getSupportedLanguages, getUsedLanguage, setPropertiesByLocale};


// WEBPACK FOOTER //
// ./src/app/utils/i18n.js